define('modules/common/service/InvioMail',[], function() {
    var Service = function(
        $http, 
        PATH, 
        Token, 
        Studio) {

        return function(messaggio){
           
            var hrefFascicolo = messaggio.hrefFascicolo;
            var data = jQuery.param({
                messaggio:messaggio.testo
            });

            return Studio.getId().then(function(id){
                return $http({
                    method:'POST',
                    url: 'https://' + PATH.ENTRYPOINT + '/' + id + '/' + hrefFascicolo + '/richiestainformazioni',
                    headers: {
                       'Content-Type': 'application/x-www-form-urlencoded',
                       'Authorization': 'TOKEN:' + Token.get()
                    },
                    data:data
                });
            });
        };
    };

    return [
        "$http", 
        "PATH", 
        "Token", 
        "Studio",
        Service
    ];
});
